var FormComponent = /** @class */ (function () {
    function FormComponent(children, options) {
        this.children = children;
        this.options = options;
    }
    FormComponent.prototype.render = function () {
        var _a, _b;
        return {
            tag: "form",
            attr: { class: (_a = this.options) === null || _a === void 0 ? void 0 : _a.class, style: (_b = this.options) === null || _b === void 0 ? void 0 : _b.style },
            children: this.children
        };
    };
    FormComponent.prototype.validate = function () {
        var valid = true;
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.validate && !c.validate()) {
                valid = false;
            }
        }
        return valid;
    };
    return FormComponent;
}());
export { FormComponent };
